var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "language-settings" },
    [
      _c(
        "DropDownsMenu",
        {
          attrs: {
            open: _vm.open,
            options: _vm.langOptions,
            "default-value": this.config.language,
          },
          on: { change: _vm.selectOption },
        },
        [[_c("img", { attrs: { src: _vm.getFlagUrl } })]],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }